var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrophyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.17,
    height: 17.17,
    viewBox: "0 0 17.17 17.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ico_trofeo_relleno",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "estrella-del-trofeo_1_",
    "data-name": "estrella-del-trofeo (1)",
    d: "M10.058,11.446h.673c4.752,0,6.439-2.505,6.439-4.65a2.5,2.5,0,0,0-2.084-2.462A8.3,8.3,0,0,0,15.7,2.569,2.119,2.119,0,0,0,15.258.8,2.164,2.164,0,0,0,13.576,0H3.594A2.165,2.165,0,0,0,1.911.8a2.118,2.118,0,0,0-.439,1.771,8.353,8.353,0,0,0,.61,1.765A2.5,2.5,0,0,0,0,6.8c0,2.145,1.686,4.65,6.439,4.65h.667a3.324,3.324,0,0,1,.048.456v2.406a1.347,1.347,0,0,1-1.431,1.431H3.577v1.431H13.593V15.738H11.447a1.349,1.349,0,0,1-1.437-1.431V11.9a3.215,3.215,0,0,1,.048-.456Zm4.274-5.723h.334A1.074,1.074,0,0,1,15.739,6.8c0,1.557-1.425,3.219-5.117,3.219a2.575,2.575,0,0,1,.451-.466A15.025,15.025,0,0,0,14.332,5.723ZM1.431,6.8A1.074,1.074,0,0,1,2.5,5.723h.332A15.008,15.008,0,0,0,6.092,9.55a2.623,2.623,0,0,1,.451.466c-3.692,0-5.112-1.663-5.112-3.219ZM8.96,2.861,9.426,4.3h1.509l.215.657-1.22.887L10.4,7.275l-.559.406L8.617,6.8l-1.223.885-.559-.406L7.3,5.84l-1.22-.887L6.3,4.3H7.8l.466-1.431.69,0Z",
    transform: "translate(0 0.001)",
    fill: "#5b5e72"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyIcon);
export default __webpack_public_path__ + "static/media/trophy-icon.85a131065c8e8cf748acabb1d7766e3f.svg";
export { ForwardRef as ReactComponent };